import React from 'react'
import { makeStyles } from '@material-ui/core'
import TaskContentContainer from '../tasks/TaskContentContainer'

// import navigateToGoSite from '../../../helpers/NavigateToGoSite'
import EquipmentTable from './EquipmentTable';

const GuideGearUp = () => {
  const classes = useStyles()
  return (
    <TaskContentContainer>
      <div className={classes.container}>
        <p>
          On your journey to a fitter, leaner and much stronger you, it will make the world of difference if you have
          the right mindset, and what helps that mindset is if you feel mentally confident and physically supported,
          that’s what ‘Gear Up’ is all about.
        </p>
        <p>
          <b>How often you&apos;ll be Training</b>
        </p>
        <ul>
          <li>
            <b>Move & Move 2:</b> 4 days of training includes fitness, toning, core and stretch (after Week 8)
          </li>
          <li>
            <b>Beginner, Intermediate & Advanced:</b> 6 days of training includes fitness, toning, core and stretch
          </li>
          <li>
            <b>Lean & Strong:</b> 6 days of training includes strength, toning, fitness/fat burning and core and stretch
          </li>
          <li>
            <b>Running:</b> 6 days of training includes running, toning (strength & stability), core and stretch.
          </li>
          <li>
            <b>Fit for Fifty:</b> 5 days of training includes strength, toning, flexibility and balance
          </li>
          <li>
            <b>Perimenopause:</b> 5 days of training includes strength, agility and pilates
          </li>
          <li>
            <b>Menopause:</b> 5 days of training includes strength, cardio, circuit, and pilates
          </li>
          <li>
            <b>Future Proof:</b> 5 days of training includes strength, mobility and dance.
          </li>
        </ul>
        <p><b>Training Equipment</b></p>
        <p><EquipmentTable /></p>
        <p>
          <b>Bonus Training Equipment</b>
        </p>
        <p>
          &nbsp;These items are optional, but they can be helpful if you’re working out at home and want to try all the workout videos:
        </p>
        <ul>
          <li>Resistance band</li>
          <li>Barbell set</li>
          <li>Swiss Ball</li>
          <li>Heart rate monitor – we recommend one that tracks calories burned</li>
        </ul>
      </div>
    </TaskContentContainer>
  )
}

const useStyles = makeStyles((theme) => ({}))

export default GuideGearUp
